import axiosInstance from '@/api/config.js';
import { useAuthStore } from '@/features/auth/stores/authStore.js';

export const authService = {
  async login(username, password) {
    const response = await axiosInstance.post('/api/auth/login', {
      username,
      password,
    });
    return response.data;
  },

  async refresh() {
    // refreshToken 由 HttpOnly cookie 自動帶，不需傳入 body
    const response = await axiosInstance.post('/api/auth/refresh', {});
    return response.data;
  },

  async logout() {
    const { accessToken } = useAuthStore();
    if (!accessToken) return;

    // /api/auth/logout 在攔截器的 AUTH_URLS 名單內，不會自動帶 Authorization，需手動帶入
    const response = await axiosInstance.post(
      '/api/auth/logout',
      {},
      {
        headers: { Authorization: `Bearer ${accessToken}` },
        suppressErrorToast: true,
      },
    );
    return response.data;
  },
};
